// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homepage-container {
  font-family: 'Roboto', sans-serif;
  color: #333;
  transition: background-color 0.5s ease-in-out;
  overflow: hidden;
}

.content-container {
  margin-left: 221px;
  transition: margin-left 0.5s ease;
}

.content-container.shift-left {
  margin-left: 0;
  transition: ease-in 0.5s;
}

.section-container {
  display: flex;
  margin-top: 250px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  max-height: -moz-fit-content;
  max-height: fit-content;
  padding: 20px;
}

.section-container h1 {
  font-size: 2.5rem;
  margin-top: 250px;
  margin-bottom: 8%;
  font-weight: normal;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  letter-spacing: 0.5ch;
  color: black;
}

@media only screen and (max-width: 1300px) {
  .content-container {
    margin-left: 170px;
  }

  .section-container h1 {
    font-size: 1.8rem;
    margin-top: 14%;
    color: black;
  }

  .section-container {
    margin-top: 0px;
    min-height: 100vh;
    padding: 0px;
  }
}

@media only screen and (max-width: 750px) {
  .section-container {
    display: flex;
    margin-top: 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    padding: 10px;
  }

  .content-container {
    margin-left: 0px;
  }

  .section-container h1 {
    font-size: 22px;
    margin-top: 0px;
    margin-bottom: 8%;
    font-weight: normal;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    letter-spacing: 0.5ch;
    color: black;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/pages-style/homepage.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,WAAW;EACX,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,4BAAuB;EAAvB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gDAAgD;EAChD,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gDAAgD;IAChD,qBAAqB;IACrB,YAAY;EACd;;AAEF","sourcesContent":[".homepage-container {\n  font-family: 'Roboto', sans-serif;\n  color: #333;\n  transition: background-color 0.5s ease-in-out;\n  overflow: hidden;\n}\n\n.content-container {\n  margin-left: 221px;\n  transition: margin-left 0.5s ease;\n}\n\n.content-container.shift-left {\n  margin-left: 0;\n  transition: ease-in 0.5s;\n}\n\n.section-container {\n  display: flex;\n  margin-top: 250px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  max-height: fit-content;\n  padding: 20px;\n}\n\n.section-container h1 {\n  font-size: 2.5rem;\n  margin-top: 250px;\n  margin-bottom: 8%;\n  font-weight: normal;\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\n  letter-spacing: 0.5ch;\n  color: black;\n}\n\n@media only screen and (max-width: 1300px) {\n  .content-container {\n    margin-left: 170px;\n  }\n\n  .section-container h1 {\n    font-size: 1.8rem;\n    margin-top: 14%;\n    color: black;\n  }\n\n  .section-container {\n    margin-top: 0px;\n    min-height: 100vh;\n    padding: 0px;\n  }\n}\n\n@media only screen and (max-width: 750px) {\n  .section-container {\n    display: flex;\n    margin-top: 0px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n    padding: 10px;\n  }\n\n  .content-container {\n    margin-left: 0px;\n  }\n\n  .section-container h1 {\n    font-size: 22px;\n    margin-top: 0px;\n    margin-bottom: 8%;\n    font-weight: normal;\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n    letter-spacing: 0.5ch;\n    color: black;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
